// Loading skeletons (premium polish T3): layout-true placeholders instead of
// a spinner floating in empty space. Hebrew reads RTL, so every group leads
// with a taller right-aligned bar (the pasuk line) followed by shorter
// English-ish bars. The shimmer sweep lives in CSS (.skel-line::after) and
// collapses to static bars under prefers-reduced-motion. Bars are decorative
// (aria-hidden); the CONTAINER carries role="status" and the accessible name.

import { el } from "../lib/dom.ts";

function bar(extra: string, width: string): HTMLElement {
  const b = el("span", extra ? `skel-line ${extra}` : "skel-line");
  b.style.width = width;
  b.setAttribute("aria-hidden", "true");
  return b;
}

// Text-line placeholder for a source body / peek: one Hebrew lead line plus
// n-1 shorter lines. Replaces the old spinner row; keeps its role="status".
export function skeletonLines(n = 3): HTMLElement {
  const d = el("div", "skel");
  d.setAttribute("role", "status");
  d.setAttribute("aria-label", "Loading...");
  d.append(bar("skel-he", "88%"));
  const widths = ["72%", "61%", "78%", "55%"];
  for (let i = 1; i < n; i++) d.append(bar("", widths[(i - 1) % widths.length]));
  return d;
}

// Full reader placeholder: a header-shaped block, the honest visible message
// ("Loading Sh'lach..."), then verse-shaped groups matching the .verse rhythm.
export function readerSkeleton(msg: string): HTMLElement {
  const d = el("div", "loading-skel");
  d.setAttribute("role", "status");
  d.setAttribute("aria-label", msg);
  const hdr = el("div", "skel-hdr");
  hdr.setAttribute("aria-hidden", "true");
  hdr.append(bar("skel-title", "34%"), bar("", "22%"));
  d.append(hdr, el("div", "loading-t", msg));
  const widths = [
    ["90%", "62%", "70%"],
    ["84%", "71%", "58%"],
    ["92%", "55%", "66%"],
  ];
  for (let i = 0; i < 6; i++) {
    const g = el("div", "skel-verse");
    g.setAttribute("aria-hidden", "true");
    const w = widths[i % widths.length];
    g.append(bar("skel-he", w[0]), bar("skel-he", w[1]), bar("", w[2]));
    d.append(g);
  }
  return d;
}
